import { axiosPath, globalAxios, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    addon_list: [],
  },
  mutations: {
    getAddonList(state, data) {
      state.addon_list = data;
    },
    changeStatus(state, res_data) {
      if (typeof res_data.add_on_stores == "string") {
        res_data.add_on_stores = JSON.parse(res_data.add_on_stores);
      }
      let index = state.addon_list.findIndex(
        (element) => element.add_on_id == res_data.add_on_id
      );
      Object.assign(state.addon_list[index], res_data);
    },
    setDelete(state, data) {
      let index = state.addon_list.findIndex(
        (element) => element.add_on_id == data.add_on_id
      );
      state.addon_list.splice(index, 1);
    },
    setCreateAddon(state, data) {
      state.addon_list.push(data);
    },
  },
  actions: {
    async getAddonList({ commit, dispatch, rootState }, province) {
      let url = `${backendVersion.version}/${province}/get_list/food/add-on`;
      return globalAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("getAddonList", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async ChangeStatusAddon(
      { commit, dispatch, rootState },
      { province, body }
    ) {
      let url = `${
        backendVersion.version
      }/${province}/chang_status/food/add-on`;
      return globalAxios
        .put(url, body)
        .then((res) => {
          if (res.msg == false) return false;
          commit("changeStatus", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async create_addon_food(
      { commit, dispatch, rootState },
      { province, payload }
    ) {
      let url = `${backendVersion.version}/${province}/manage/food/add-on`;
      return globalAxios
        .post(url, payload)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setCreateAddon", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async edit_addon_food(
      { commit, dispatch, rootState },
      { province, payload }
    ) {
      let url = `${backendVersion.version}/${province}/manage/food/add-on`;
      return globalAxios
        .put(url, payload)
        .then((res) => {
          if (res.msg == false) return false;
          commit("changeStatus", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async delete_food_addon({ commit, dispatch, rootState }, province, id) {
      let url = `${backendVersion.version}/${
        province.province
      }/manage/food/add-on?add_on_id=${province.payload.add_on_id}`;
      return globalAxios
        .delete(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("setDelete", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
  },
  getters: {},
};
